"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _isReady, _readyCallbacks, _syncObservers, __local, __remote, __remoteUser, __remotePass, __sync, __remoteSyncOptions;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GCIDataApi = void 0;
const sector_class_1 = require("./sector.class");
const regex_1 = require("./regex");
const decorators_1 = require("./decorators");
const pile_class_1 = require("./pile.class");
const report_class_1 = require("./report.class");
const util_1 = require("./util");
let GCIDataApi = class GCIDataApi {
    constructor(localDB, remoteDB, remoteUser, remotePass) {
        // private db: any;
        _isReady.set(this, false);
        _readyCallbacks.set(this, []);
        _syncObservers.set(this, []);
        __local.set(this, void 0);
        __remote.set(this, void 0);
        __remoteUser.set(this, void 0);
        __remotePass.set(this, void 0);
        __sync.set(this, null);
        __remoteSyncOptions.set(this, {
            live: true,
            retry: true,
            continuous: true,
            auto_compaction: true,
            push: { checkpoint: 'source' },
            pull: { checkpoint: 'target' }
        });
        this.lastSyncChange = null;
        this.syncEnabled = false;
        console.log("GCIDataApi INSTANCE", localDB, remoteDB, remoteUser, remotePass);
        __classPrivateFieldSet(this, __local, localDB);
        __classPrivateFieldSet(this, __remote, remoteDB);
        __classPrivateFieldSet(this, __remoteUser, remoteUser);
        __classPrivateFieldSet(this, __remotePass, remotePass);
        __classPrivateFieldGet(this, __local).info().then(() => __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, __local).createIndex({
                index: { fields: ['generated', 'sector._id'] },
                name: 'sector-reports-index',
                ddoc: 'sector-reports-index',
                type: 'json'
            });
            __classPrivateFieldSet(this, _isReady, true);
            setTimeout(() => {
                this.activateSync();
            }, 1000);
            this._flushReadyCallbacks();
        }));
        // connect(this.#_localPath, this.#_localOptions).then((connection: any) => {
        //   this.#_local = connection;
        //   this.#isReady = true;
        //   this.#readyCallbacks.forEach((callback: Function) => {
        //     callback(this);
        //   });
        // })
    }
    //   conflictResolution(){
    //     function onChange(doc:any) {
    //       if (!doc._conflicts) return;
    //       console.log('conflicts',doc._conflicts)
    //     }
    //     // collectConflicts(doc._conflicts, function(docs) {
    //     //   var master = docs.sort(byTime).unshift();
    //     //   for (var doc in docs) {
    //     //     for (var prop in doc) {
    //     //       if (!(prop in master)) {
    //     //         master[prop] = doc[prop];
    //     //       }
    //     //     }
    //     //   }
    //     //   db.put(master, function(err) {
    //     //     if (!err) {
    //     //       for (var doc in docs) {
    //     //         db.remove(doc);
    //     //       }
    //     //     }
    //     //   });
    //     // });
    //   // }
    // // }
    //
    //     this.#_local.changes({conflicts: true, onChange: onChange});
    //   }
    getInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                lastSync: this.lastSyncChange
            };
        });
    }
    _flushReadyCallbacks(error) {
        __classPrivateFieldGet(this, _readyCallbacks).forEach((callback) => {
            if (error) {
                callback.reject(error);
            }
            else {
                callback.resolve(this);
            }
        });
    }
    _onSyncDenied(err) {
        this.notifyObservers('denied', err);
        // console.log('sync denied',err);
    }
    _onSyncComplete(info) {
        this.notifyObservers('info', info);
        // console.log('sync complete',info);
    }
    _onSyncError(err) {
        this.notifyObservers('error', err);
        // console.log('sync error',err);
    }
    _onSyncActive() {
        this.notifyObservers('status', { status: 'active' });
        // console.log('sync active');
    }
    _onSyncPaused() {
        this.notifyObservers('status', { status: 'paused' });
        // console.log('sync paused');
    }
    _onSyncChange(info) {
        this.notifyObservers('change', info);
        // console.log('sync change',info);
        this.lastSyncChange = info;
    }
    activateSync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.syncEnabled)
                return;
            try {
                const login = yield __classPrivateFieldGet(this, __remote).login(__classPrivateFieldGet(this, __remoteUser), __classPrivateFieldGet(this, __remotePass));
            }
            catch (E) {
                console.log('LOGINERROR', E, __classPrivateFieldGet(this, __remoteUser), __classPrivateFieldGet(this, __remotePass));
            }
            __classPrivateFieldGet(this, __local).setMaxListeners(20);
            __classPrivateFieldGet(this, __remote).setMaxListeners(20);
            __classPrivateFieldSet(this, __sync, __classPrivateFieldGet(this, __local).sync(__classPrivateFieldGet(this, __remote), __classPrivateFieldGet(this, __remoteSyncOptions)).on('denied', this._onSyncDenied.bind(this))
                .on('complete', this._onSyncComplete.bind(this))
                .on('error', this._onSyncError.bind(this))
                .on('paused', this._onSyncPaused.bind(this))
                .on('active', this._onSyncActive.bind(this))
                .on('change', this._onSyncChange.bind(this)));
            this.syncEnabled = true;
        });
    }
    cancelSync() {
        if (__classPrivateFieldGet(this, __sync) !== null) {
            __classPrivateFieldGet(this, __sync).cancel();
            __classPrivateFieldSet(this, __sync, null);
        }
        this.syncEnabled = false;
    }
    nextSectorKey() {
        return __awaiter(this, void 0, void 0, function* () {
            const allDocs = yield __classPrivateFieldGet(this, __local).allDocs();
            const sectorNumbers = allDocs.rows.reduce((ids, row) => {
                if (/^s\:\d+$/.test(row.id)) {
                    ids.push(row.id.replace(/s\:/, ''));
                }
                return ids;
            }, []);
            sectorNumbers.push(0);
            const last = Math.max.apply(Math, sectorNumbers);
            return `s:${last + 1}`;
        });
    }
    notifyObservers(syncEvent, syncData) {
        if (__classPrivateFieldGet(this, _syncObservers).filter(s => s !== null).length == 0)
            return;
        __classPrivateFieldGet(this, _syncObservers).forEach((o) => __awaiter(this, void 0, void 0, function* () {
            if (o !== null) {
                try {
                    yield o(syncEvent, syncData);
                }
                catch (Ignore) {
                    Ignore;
                }
            }
        }));
    }
    setNetworkStatus(hasNetwork) {
        if (!hasNetwork) {
            this.cancelSync();
        }
        else {
            this.activateSync();
        }
    }
    subscribe(observer) {
        let index = __classPrivateFieldGet(this, _syncObservers).push(observer);
        let id = index - 1;
        observer('status', { status: 'waiting' });
        return {
            id: id,
            unsubscribe: () => {
                __classPrivateFieldGet(this, _syncObservers)[id] = null;
            }
        };
    }
    whenReady() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _isReady))
                return this;
            return new Promise((resolve, reject) => {
                __classPrivateFieldGet(this, _readyCallbacks).push({ resolve, reject });
            });
        });
    }
    getSector(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            let doc;
            try {
                doc = yield __classPrivateFieldGet(this, __local).get(sectorUID);
            }
            catch (E) {
                // console.log(E);
                throw new Error(`Sector Not Found: "${sectorUID}"`);
            }
            return new sector_class_1.Sector(doc);
        });
    }
    getAllSectors() {
        return __awaiter(this, void 0, void 0, function* () {
            let docs = [];
            try {
                const result = yield __classPrivateFieldGet(this, __local).allDocs({
                    startkey: `s:`,
                    endkey: `s:\ufff0`,
                    include_docs: false
                });
                const rows = result.rows;
                const ids = rows.map((r) => r.id).filter((k) => regex_1.sectorKeyRegex.test(k));
                if (ids.length === 0)
                    return [];
                const docResults = yield __classPrivateFieldGet(this, __local).allDocs({
                    include_docs: true,
                    keys: ids
                });
                docs = docResults.rows.map((r) => r.doc);
            }
            catch (E) {
                console.log(E);
                throw new Error(`No Sectors Found`);
            }
            const sectors = docs.map((d) => new sector_class_1.Sector(d));
            return sectors;
        });
    }
    getPile(pileUID) {
        return __awaiter(this, void 0, void 0, function* () {
            let doc;
            try {
                doc = yield __classPrivateFieldGet(this, __local).get(pileUID);
            }
            catch (E) {
                // console.log(E);
                throw new Error(`Pile Not Found: "${pileUID}"`);
            }
            return new pile_class_1.Pile(doc);
        });
    }
    getPilesForSector(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            let docs = [];
            try {
                const result = yield __classPrivateFieldGet(this, __local).allDocs({
                    startkey: `${sectorUID}:p:`,
                    endkey: `${sectorUID}:p:\ufff0`,
                    include_docs: true
                });
                if (result.rows) {
                    docs = result.rows.map((row) => {
                        return row.doc;
                    });
                }
            }
            catch (E) {
                throw new Error(`No Piles Found For Sector: "${sectorUID}"`);
            }
            return docs.map((d) => {
                return new pile_class_1.Pile(d);
            });
        });
    }
    createSector(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const UID = yield this.nextSectorKey();
            const sector = sector_class_1.Sector.create(UID, data);
            const doc = sector.toDoc();
            yield __classPrivateFieldGet(this, __local).put(doc);
            return sector;
        });
    }
    createPile(sectorUID, pileNumber, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const pileUID = `${sectorUID}:p:${pileNumber}`;
            const pile = pile_class_1.Pile.create(sectorUID, pileUID, data);
            const doc = pile.toDoc();
            yield __classPrivateFieldGet(this, __local).put(doc);
            return pile;
        });
    }
    updateSector(data) {
        return __awaiter(this, void 0, void 0, function* () {
            data = data instanceof sector_class_1.Sector ? data.toJSON() : data;
            const sectorUID = data.uid;
            if (!regex_1.sectorKeyRegex.test(sectorUID)) {
                throw new Error('Cannot update, sector has invalid uid');
            }
            const oldRevision = yield __classPrivateFieldGet(this, __local).get(sectorUID);
            const modifiedData = Object.assign({}, oldRevision, data);
            // console.log('modifyin',modifiedData);
            yield __classPrivateFieldGet(this, __local).put(modifiedData);
            const sector = new sector_class_1.Sector(modifiedData);
            return sector;
        });
    }
    _updatePileHistory(pile) {
        const historyItem = new pile_class_1.Pile(pile).toHistoryItem();
        const history = pile.history || [];
        history.push(historyItem);
        return history;
    }
    updatePile(data) {
        return __awaiter(this, void 0, void 0, function* () {
            data = data instanceof pile_class_1.Pile ? data.toJSON() : data;
            const pileUID = data.uid;
            if (!regex_1.pileKeyRegex.test(pileUID)) {
                throw new Error('Cannot update, pile has invalid uid');
            }
            const oldRevision = yield __classPrivateFieldGet(this, __local).get(pileUID);
            const oldMeasures = oldRevision.measures || {};
            const oldStatus = oldRevision.status;
            const newMeasures = Object.assign({}, oldMeasures, data.measures || {});
            const oldPosition = oldRevision.position || {};
            const newPosition = Object.assign({}, oldPosition, data.position || {});
            Object.assign(data, {
                measures: newMeasures,
                position: newPosition,
                history: this._updatePileHistory(oldRevision)
            });
            let newStatus = data.status || oldStatus;
            // console.log('sttus before', oldStatus, oldMeasures )
            if (data.status != 'transported') {
                // console.log('isCompleteMeasures',isCompleteMeasures(newMeasures))
                if (util_1.isCompleteMeasures(newMeasures)) {
                    if (oldStatus == 'new') {
                        newStatus = 'inventory';
                    }
                    else if (oldStatus == 'inventory') {
                        if (!util_1.isSameMeasure(oldMeasures, newMeasures)) {
                            newStatus = 'modified';
                            data.modified = new Date();
                        }
                    }
                    else if (oldStatus == 'modified' && !util_1.isSameMeasure(oldMeasures, newMeasures)) {
                        data.modified = new Date();
                    }
                }
            }
            if (data.status && data.status == 'transported' && oldRevision.status !== 'transported') {
                data.transported = new Date();
            }
            data.status = newStatus;
            // console.log('sttus after', newStatus,newMeasures )
            const modifiedData = Object.assign({}, oldRevision, data);
            yield __classPrivateFieldGet(this, __local).put(modifiedData);
            const pile = new pile_class_1.Pile(modifiedData);
            return pile;
        });
    }
    deleteSector(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!regex_1.sectorKeyRegex.test(sectorUID)) {
                throw new Error('Cannot delete, invalid uid');
            }
            const oldDoc = yield __classPrivateFieldGet(this, __local).get(sectorUID);
            yield __classPrivateFieldGet(this, __local).remove(oldDoc);
            return true;
        });
    }
    deletePile(pileUID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!regex_1.pileKeyRegex.test(pileUID)) {
                throw new Error('Cannot delete, invalid uid');
            }
            const oldDoc = yield __classPrivateFieldGet(this, __local).get(pileUID);
            yield __classPrivateFieldGet(this, __local).remove(oldDoc);
            return true;
        });
    }
    generateReport(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            let sectorDoc;
            let pileDocs = [];
            try {
                sectorDoc = yield __classPrivateFieldGet(this, __local).get(sectorUID);
                const pileResult = yield __classPrivateFieldGet(this, __local).allDocs({
                    startkey: `${sectorUID}:p:`,
                    endkey: `${sectorUID}:p:\ufff0`,
                    include_docs: true
                });
                if (pileResult.rows) {
                    pileDocs = pileResult.rows.map((row) => {
                        return row.doc;
                    });
                }
            }
            catch (E) {
                throw new Error(`Could not generate report for sector "${sectorUID}"`);
            }
            const report = report_class_1.Report.create(sectorDoc, pileDocs);
            const doc = report.toDoc();
            yield __classPrivateFieldGet(this, __local).put(doc);
            return report;
        });
    }
    getReport(reportUID) {
        return __awaiter(this, void 0, void 0, function* () {
            let doc;
            try {
                doc = yield __classPrivateFieldGet(this, __local).get(reportUID);
            }
            catch (E) {
                // console.log(E);
                throw new Error(`Report Not Found: "${reportUID}"`);
            }
            return new report_class_1.Report(doc);
        });
    }
    getReportsForSector(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            let docs = [];
            try {
                const query = {
                    selector: {
                        "$and": [
                            {
                                generated: {
                                    "$exists": true
                                }
                            },
                            {
                                "sector._id": sectorUID
                            }
                        ]
                    },
                    use_index: 'sector-reports-index'
                };
                const result = yield __classPrivateFieldGet(this, __local).find(query);
                if (result.docs) {
                    docs = result.docs;
                }
            }
            catch (E) {
                // console.log(E)
                throw new Error(`No Reports Found For Sector: "${sectorUID}"`);
            }
            return docs.map((d) => {
                return new report_class_1.Report(d);
            });
        });
    }
    addSectorAttachment(sectorUID, fileData) {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = yield __classPrivateFieldGet(this, __local).get(sectorUID);
            const result = yield __classPrivateFieldGet(this, __local).putAttachment(sectorUID, fileData.name, doc._rev, fileData.data, fileData.type);
            return Object.assign(fileData, {
                upload: result
            });
        });
    }
    bulkAddSectorAttachments(sectorUID, fileData) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = [];
            let lastRev;
            const doc = yield __classPrivateFieldGet(this, __local).get(sectorUID, { include_docs: false, attachments: false });
            lastRev = doc._rev;
            for (const data of fileData) {
                const result = yield __classPrivateFieldGet(this, __local).putAttachment(sectorUID, data.name, lastRev, data.data, data.type);
                lastRev = result.rev;
                results.push(Object.assign(data, {
                    upload: result
                }));
            }
            return results;
        });
    }
    getSectorAttachments(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = yield __classPrivateFieldGet(this, __local).get(sectorUID, { attachments: true, include_docs: false });
            const attachments = [];
            if (doc._attachments) {
                Object.keys(doc._attachments).forEach((name) => {
                    const file = new File([doc._attachments[name].data], name, {
                        type: doc._attachments[name].content_type
                    });
                    attachments.push(file);
                });
            }
            return attachments;
        });
    }
    clearSectorAttachments(sectorUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = yield __classPrivateFieldGet(this, __local).get(sectorUID, { attachments: false, include_docs: false });
            let filenames = [];
            if (doc._attachments) {
                filenames = Object.keys(doc._attachments);
            }
            for (const filename of filenames) {
                yield this.deleteSectorAttachment(sectorUID, filename);
            }
            return true;
        });
    }
    deleteSectorAttachment(sectorUID, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = yield __classPrivateFieldGet(this, __local).get(sectorUID);
            const result = yield __classPrivateFieldGet(this, __local).removeAttachment(sectorUID, filename, doc._rev);
            return true;
        });
    }
};
_isReady = new WeakMap(), _readyCallbacks = new WeakMap(), _syncObservers = new WeakMap(), __local = new WeakMap(), __remote = new WeakMap(), __remoteUser = new WeakMap(), __remotePass = new WeakMap(), __sync = new WeakMap(), __remoteSyncOptions = new WeakMap();
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GCIDataApi.prototype, "getInfo", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_flushReadyCallbacks", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_onSyncDenied", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_onSyncComplete", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_onSyncError", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_onSyncActive", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_onSyncPaused", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "_onSyncChange", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], GCIDataApi.prototype, "activateSync", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GCIDataApi.prototype, "cancelSync", null);
GCIDataApi = __decorate([
    decorators_1.Sealed(),
    __metadata("design:paramtypes", [Object, Object, String, String])
], GCIDataApi);
exports.GCIDataApi = GCIDataApi;
